var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"min-width":"1366px","max-width":"1920px"}},[_c('v-expand-transition',[(_vm.expandTable)?_c('v-row',{ref:"content"},[_c('v-col',{staticClass:"mb-0 pt-0 mt-0"},[_c('configured-options-list-chart')],1)],1):_vm._e()],1),_c('v-expand-transition',[_c('configured-options-table',{on:{"expand":_vm.tableExpandEvent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }